import { render, staticRenderFns } from "./editGradeModal.vue?vue&type=template&id=0d4cda24&"
import script from "./editGradeModal.vue?vue&type=script&lang=js&"
export * from "./editGradeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports